import { useSelector } from 'react-redux'
import { parseISOToDateTime } from '@calendly/datetime'
import styled from 'astroturf/react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
import { formatDate, formatTime } from '@calendly/booking-kit/services/time_format'
import { BodyText } from '@calendly/ui/components/typography'
import { FlexLayout } from '@calendly/ui/components/flex-layout'

import { calendarInviteeEventsByDaySelector } from 'selectors/calendars'
import { currentUserLocaleSelector } from 'selectors/user'
import { useI18n } from 'locales'
import _InviteeEventsContainer from "invitee_events_list-InviteeEventsContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_events_list.js?styleId=InviteeEventsContainer";
import _EventContainer from "invitee_events_list-EventContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_events_list.js?styleId=EventContainer";
import _DayContainer from "invitee_events_list-DayContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_events_list.js?styleId=DayContainer";
import _EmptyMessage from "invitee_events_list-EmptyMessage.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_events_list.js?styleId=EmptyMessage";


const InviteeEventsContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InviteeEventsContainer",
  styles: _InviteeEventsContainer
})

const EventContainer = /*#__PURE__*/styled('div', null, {
  displayName: "EventContainer",
  styles: _EventContainer
})

const DayContainer = /*#__PURE__*/styled('div', null, {
  displayName: "DayContainer",
  styles: _DayContainer
})

const EmptyMessage = /*#__PURE__*/styled('div', null, {
  displayName: "EmptyMessage",
  styles: _EmptyMessage
})

const Day = ({ date, inviteeEvents }) => {
  const { i18n } = useI18n()
  return (
    <DayContainer>
      <FlexLayout direction="column" gap={16}>
        <BodyText weight="bold" size="medium" color="muted">
          {formatDate(parseISOToDateTime(date), i18n.t('time.formats.date_extra'))}
        </BodyText>
        <div>
          {inviteeEvents.map((inviteeEvent) => <InviteeEvent event={inviteeEvent} />)}
        </div>
      </FlexLayout>
    </DayContainer>
  )
}

const InviteeEvent = ({ event: { start_time: startTime, end_time: endTime, event_name: eventName } }) => (
  <EventContainer>
    <BodyText size="medium">
      {formatTime(parseISOToDateTime(startTime))}
      {' '}
      -
      {' '}
      {formatTime(parseISOToDateTime(endTime))}
    </BodyText>
    <BodyText weight="bold" size="medium">{eventName}</BodyText>
  </EventContainer>
)

const InviteeEventsList = () => {
  const { i18n } = useI18n()
  const inviteeEventsByDay = useSelector(calendarInviteeEventsByDaySelector)
  const locale = useSelector(currentUserLocaleSelector)

  return (
    <InviteeEventsContainer>
      {
        inviteeEventsByDay.length === 0
          && (
          <EmptyMessage>
            <BodyText size="medium" weight="bold">{i18n.t('publisher.mutual_availability.no_events', { locale })}</BodyText>
          </EmptyMessage>
          )
      }
      {
        inviteeEventsByDay.map(([date, inviteeEvents]) => (
          <Day key={date} date={date} inviteeEvents={inviteeEvents} />
        ))
      }
    </InviteeEventsContainer>
  )
}

export default InviteeEventsList
